import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["input"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useEffect, useMemo, useRef } from 'react';
import moment from 'moment';
import { useForm } from 'react-final-form';
import { useTranslate } from "lib/translate";
import { Checkbox, Expandable } from '@haldor/ui';

var BlockCoreContentField = function BlockCoreContentField(_ref) {
  var _form$getFieldState2;

  var input = _ref.input,
      props = _objectWithoutProperties(_ref, _excluded);

  var translate = useTranslate();
  var values = [];

  if (input.value != null && input.value != "") {
    values = JSON.parse(JSON.stringify(input.value));
  }

  var forbiddenText = "Undervisningen i kursen ska behandla följande centrala innehåll:";
  var form = useForm();
  var currentRows = useRef([]);

  var _useMemo = useMemo(function () {
    var _form$getFieldState;

    var value = (_form$getFieldState = form.getFieldState('assessmentBlocks')) === null || _form$getFieldState === void 0 ? void 0 : _form$getFieldState.value;

    if (value == null || value.length == 0) {
      return {
        courses: [],
        assessmentBlockPartRows: []
      };
    }

    var courses = [];
    var blockPartRows = [];
    var blocks = value.filter(function (b) {
      return b.type === 'Haldor.Blocks.AssessmentBlock';
    });
    blocks.forEach(function (items) {
      var resources = items.resources.filter(function (s) {
        return s["@odata.type"] === 'Haldor.Blocks.AssessmentBlockPart' && s.referenceType === 'matrix';
      });

      if (resources) {
        resources.forEach(function (resource) {
          var course = JSON.parse(JSON.stringify(resource));
          var inCourses = courses.find(function (r) {
            var _r$value, _course$value;

            return ((_r$value = r.value) === null || _r$value === void 0 ? void 0 : _r$value.id) == ((_course$value = course.value) === null || _course$value === void 0 ? void 0 : _course$value.id);
          });

          if (inCourses == null) {
            var _course$value2;

            var details = course === null || course === void 0 ? void 0 : (_course$value2 = course.value) === null || _course$value2 === void 0 ? void 0 : _course$value2.details.filter(function (x) {
              return x.endDate == null || moment(x.endDate).isAfter(moment());
            });
            course.value.details = details;
            courses.push(course.value);
          }

          resource.assessmentBlockPartRows.forEach(function (blockPartRow) {
            var relations = [];
            resource.value.details.forEach(function (detail) {
              detail.matrixRelationships.forEach(function (relationship) {
                if (relationship.matrixRowId == blockPartRow.referenceId && blockPartRow.referenceType == 'matrixRow') {
                  relations.push(relationship);
                }
              });
            });
            blockPartRows = [].concat(_toConsumableArray(blockPartRows), [_objectSpread(_objectSpread({}, blockPartRow), {}, {
              relations: relations
            })]);
          });
        });
      }
    });
    return {
      courses: courses,
      assessmentBlockPartRows: blockPartRows
    };
  }, [(_form$getFieldState2 = form.getFieldState('assessmentBlocks')) === null || _form$getFieldState2 === void 0 ? void 0 : _form$getFieldState2.value]),
      assessmentBlockPartRows = _useMemo.assessmentBlockPartRows,
      courses = _useMemo.courses;
  /**
   * @param {object} row
   * @param {object} aspect
   * @param {number} courseDetailsId
   * @returns {object} coreContent
   */


  var _generateCoreContent = function _generateCoreContent(row, aspect, courseDetailsId) {
    return {
      courseDetailsId: courseDetailsId,
      title: null,
      aspects: [{
        title: null,
        id: aspect.id,
        aspectRows: [{
          id: row.id,
          text: null
        }]
      }]
    };
  };
  /**
   * @param {object} row
   * @param {object} aspect
   * @param {number} courseDetailsId
   * @param {boolean} force
   */


  var toggleRow = function toggleRow(row, aspect, courseDetailsId) {
    var force = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

    if (values.length == 0) {
      values.push({
        referenceType: props.referenceType,
        referenceId: props.referenceId,
        coreContents: [_generateCoreContent(row, aspect, courseDetailsId)]
      });
      input.onChange(values);
      return true;
    }

    var isSelected = isRowSelected(row);
    values.map(function (value) {
      var _value$coreContents;

      var foundCoreContent = (_value$coreContents = value.coreContents) === null || _value$coreContents === void 0 ? void 0 : _value$coreContents.find(function (coreContent) {
        return coreContent.courseDetailsId == courseDetailsId;
      });

      if (foundCoreContent == null) {
        if (value.coreContents == null) {
          value.coreContents = [];
        }

        value.coreContents.push(_generateCoreContent(row, aspect, courseDetailsId));
        return value;
      }

      foundCoreContent.aspects = foundCoreContent.aspects.map(function (aspect) {
        if (isSelected) {
          if (!force) {
            aspect.aspectRows = aspect.aspectRows.filter(function (_row) {
              return _row.id != row.id;
            });
          }
        } else {
          aspect.aspectRows.push({
            id: row.id,
            text: null
          });
        }

        return aspect;
      });
      return value;
    });
    input.onChange(values);
  };
  /**
   * @param {object} row
   * @returns {boolean} selected
   */


  var isRowSelected = function isRowSelected(row) {
    if (input.value == null || input.value == "") {
      return false;
    }

    var inValues = input.value.find(function (value) {
      var _value$coreContents2;

      return (_value$coreContents2 = value.coreContents) === null || _value$coreContents2 === void 0 ? void 0 : _value$coreContents2.find(function (coreContent) {
        return coreContent.aspects.find(function (aspect) {
          return aspect.aspectRows.find(function (_row) {
            return _row.id == row.id;
          });
        });
      });
    });
    return inValues != null;
  };

  useEffect(function () {
    if (currentRows.current.length !== (assessmentBlockPartRows === null || assessmentBlockPartRows === void 0 ? void 0 : assessmentBlockPartRows.length)) {
      currentRows.current = assessmentBlockPartRows;
      assessmentBlockPartRows.forEach(function (blockPartRow) {
        blockPartRow.relations.forEach(function (relation) {
          courses.forEach(function (course) {
            var _course$details$;

            var coreContents = (_course$details$ = course.details[0]) === null || _course$details$ === void 0 ? void 0 : _course$details$.coreContent;

            if (coreContents == null) {
              return null;
            }

            coreContents.forEach(function (coreContent) {
              coreContent.aspects.forEach(function (aspect) {
                var aspectRow = aspect.aspectRows.find(function (aspectRow) {
                  return aspectRow.id == relation.aspectRowId;
                });

                if (aspectRow != null) {
                  toggleRow(aspectRow, aspect, course.details[0].id, true);
                }
              });
            });
          });
        });
      });
    }
  }, [assessmentBlockPartRows]);
  return /*#__PURE__*/React.createElement("div", {
    className: "core-content"
  }, courses.length > 0 ? courses.map(function (course) {
    var _course$details$2;

    var coreContents = (_course$details$2 = course.details[0]) === null || _course$details$2 === void 0 ? void 0 : _course$details$2.coreContent;

    if (coreContents == null) {
      return /*#__PURE__*/React.createElement("p", null, translate('No knowledge requirements selected'));
    }

    return /*#__PURE__*/React.createElement(Expandable, {
      title: course.title + " " + (course.year != null ? course.year : "") + " (" + course.courseCode + ") ",
      key: course.id,
      color: course.colorCode
    }, coreContents.map(function (coreContent) {
      return /*#__PURE__*/React.createElement("div", {
        key: coreContent.id
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h2", null, coreContent.title)), coreContent.aspects.map(function (aspect) {
        return /*#__PURE__*/React.createElement("div", {
          key: 'corecontent-aspects-' + aspect.id,
          className: "aspects"
        }, /*#__PURE__*/React.createElement("h3", null, aspect.title != forbiddenText ? aspect.title : ''), aspect.aspectRows.map(function (row) {
          return /*#__PURE__*/React.createElement("div", {
            key: 'aspect-row-' + row.id,
            className: "aspect-row"
          }, /*#__PURE__*/React.createElement(Checkbox, {
            label: row.text,
            value: isRowSelected(row),
            onChange: function onChange() {
              return toggleRow(row, aspect, course.details[0].id);
            }
          }));
        }));
      }));
    }));
  }) : /*#__PURE__*/React.createElement("p", null, translate('No knowledge requirements selected')));
};

BlockCoreContentField.defaultProps = {
  referenceId: 0,
  referenceType: "Planning"
};
export default BlockCoreContentField;